import Router from 'vue-router';
import Vue from 'vue';
import { routes } from './routes';
import MtaH5 from 'mta-h5-analysis';

Vue.use(Router);

const shouldStatistics = window.location.href.indexOf('ecaray.com') !== -1;

if (shouldStatistics) {
  MtaH5.init({
    sid: '500696764', //必填，统计用的appid
    cid: '500696765', //如果开启自定义事件，此项目为必填，否则不填
    autoReport: 0, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
    senseHash: 1, //hash锚点是否进入url统计
    senseQuery: 1, //url参数是否进入url统计
    performanceMonitor: 1, //是否开启性能监控
    ignoreParams: [], //开启url参数上报时，可忽略部分参数拼接上报
  });
}

const router = new Router({
  routes,
});
const reg = /[\u4e00-\u9fa5]/gm; // 匹配中文
router.beforeEach((to, from, next) => {
  const { name } = to;
  const { title } = to.meta;
  if (name && reg.test(name)) {
    document.title = name;
  }
  if (title) {
    document.title = title;
  }
  if (shouldStatistics) {
    MtaH5.pgv();
  }
  next();
});

export default router;
